'use strict';

require('prop-types');
var React = require('react');
var StarBorder = require('../../../../IconsAndImages/Icons/StarBorder.js');
var StarOneQuarter = require('../../../../IconsAndImages/Icons/StarOneQuarter.js');
var StarHalf = require('../../../../IconsAndImages/Icons/StarHalf.js');
var StarThreeQuarters = require('../../../../IconsAndImages/Icons/StarThreeQuarters.js');
var Star = require('../../../../IconsAndImages/Icons/Star.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function StarRating(_ref) {
  var reviewSiteBrandColor = _ref.reviewSiteBrandColor,
      rating = _ref.rating,
      size = _ref.size;

  var getFullRating = function getFullRating() {
    return Math.floor(rating);
  };

  var getPartialRating = function getPartialRating() {
    return Math.round((rating - Math.floor(rating)) * 100);
  };

  var buildFullStars = function buildFullStars(fullRating) {
    var fullStars = [];

    for (var i = 1; i <= 5; i++) {
      if (fullRating >= i) {
        fullStars.push(React__default["default"].createElement(Star, {
          key: i,
          style: {
            fill: reviewSiteBrandColor,
            width: size,
            height: size
          }
        }));
      }
    }

    return fullStars;
  };

  var buildPartialStar = function buildPartialStar(partialRating) {
    if (partialRating < 25) {
      return React__default["default"].createElement(StarBorder, {
        key: "StarEmpty",
        style: {
          fill: reviewSiteBrandColor,
          width: size,
          height: size
        }
      });
    } else if (partialRating >= 25 && partialRating < 50) {
      return React__default["default"].createElement(StarOneQuarter, {
        variant: "oneQuarter",
        key: "StarOneQuarter",
        style: {
          fill: reviewSiteBrandColor,
          width: size,
          height: size
        }
      });
    } else if (partialRating >= 50 && partialRating < 75) {
      return React__default["default"].createElement(StarHalf, {
        key: "StarHalfIcon",
        style: {
          fill: reviewSiteBrandColor,
          width: size,
          height: size
        }
      });
    } else {
      return React__default["default"].createElement(StarThreeQuarters, {
        variant: "threeQuarters",
        key: "StarThreeQuarters",
        style: {
          fill: reviewSiteBrandColor,
          width: size,
          height: size
        }
      });
    }
  };

  var buildEmptyStars = function buildEmptyStars(starsUsed) {
    var emptyStars = [];

    for (var i = starsUsed; i < 5; i++) {
      emptyStars.push(React__default["default"].createElement(StarBorder, {
        key: i,
        style: {
          fill: reviewSiteBrandColor,
          width: size,
          height: size
        }
      }));
    }

    return emptyStars;
  };

  var buildStars = function buildStars() {
    var stars = buildFullStars(getFullRating());

    if (stars.length < 5) {
      stars.push(buildPartialStar(getPartialRating()));
    }

    stars = stars.concat(buildEmptyStars(stars.length));
    return stars;
  };

  return React__default["default"].createElement(React.Fragment, null, buildStars());
}
StarRating.defaultProps = {
  reviewSiteBrandColor: "#ffab00",
  size: 16
};

module.exports = StarRating;
